import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

const dictionary = {
  'discounts.discount_applied_at_checkout': {
    'en-GB':
      'Don’t forget to hit “Apply Voucher” in the basket to apply the discount.',
    'nl-NL':
      "Let op: klik of tik nog wel even op de button met 'Kortingscode toepassen'.",
  },
  'discounts.discount_heading': {
    'en-GB': 'Discount added to basket!',
    'nl-NL': 'Je kortingscode staat klaar in je winkelmandje',
  },
}

export const useLocaleText = createLocaleTextHook({
  dictionary,
})
